import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import {GlobalVariable} from './../global';

@Injectable({
  providedIn: 'root'
})
export class AssociatesManagementService {
  private baseUrl: string = GlobalVariable.BASE_URL;   
  constructor(private http: HttpClient, private auth: AuthService) { }

  getAssociates(enabled: any, userType: any) {
    
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/user/by-approver?enabled='+enabled+'&userType='+userType;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }

  updateStatus(Obj: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/user/enable-disable';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.put<any>(apiUrl, Obj,{ headers });
  }
  
  restPasswordDb(Obj: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/user/passwordreset';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.put<any>(apiUrl, Obj,{ headers });
  }
}
